<template>
    <div class="itemtypes-list">
        <v-card>
            <v-card-title style="background-color: rgb(33, 57, 141); color: white;">Tasks</v-card-title>
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="desserts"
                        class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.create_date }}</td>
                        <td>{{ props.item.due_date }}</td>
                        <td>{{ props.item.remaining_days }}</td>
                        <td>{{ props.item.actions }}</td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script  >
    import { Component, Vue } from 'vue-property-decorator';
    import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

    @Component({
        components: {
            HelloWorld,
        },
    })

    export default class ItemTypesList extends Vue {

        data () {
            return {
                headers: [
                    { text: 'Name', value: 'name'},
                    { text: 'Erstellungsdatum', value: 'create_date'},
                    { text: 'Fälligkeitsdatum', value: 'due_date'},
                    { text: 'Verbleibene Tage', value: 'remaining_days'},
                    { text: 'Aktion', value: 'actions' }
                ],
                desserts: [
                    {
                        name: 'F242221 freigeben',
                        create_date: '21.10.19',
                        due_date: '25.10.19',
                        remaining_days: '4 days',
                        actions: 'Öffnen , Erledigt'
                    },
                    {
                        name: 'F244422 prüfen',
                        create_date: '21.10.19',
                        due_date: '25.10.19',
                        remaining_days: '4 days',
                        actions: 'Öffnen , Erledigt'
                    },
                    {
                        name: 'F244422 kommentar lesen',
                        create_date: '21.10.19',
                        due_date: '25.10.19',
                        remaining_days: '4 days',
                        actions: 'Öffnen , Erledigt'
                    }
                ]
            };
        }

    }
</script>
